import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Partner, Referral } from '@kanda-libs/ks-frontend-services';

import { selectors } from 'store';

export interface PartnerReferralsHook {
  referrals: Referral[];
  stats?: Partner['stats'];
}

export default function usePartnerReferrals(): PartnerReferralsHook {
  const partner = useSelector(selectors.partner.getEntity);

  const referrals = useMemo(() => {
    if (!partner?.referrals) return [];

    return [...partner.referrals].sort((a, b) =>
      (b?.lifecycle || '').localeCompare(a?.lifecycle || ''),
    );
  }, [partner]);

  return {
    referrals,
    stats: partner?.stats,
  };
}
